<template>
  <b-container fluid class="report-success-page py-5">
    <b-row class="justify-content-center">
      <b-col cols="12" md="8" lg="6">

        <!-- ✅ SUCCESS STATE -->
        <b-card
          v-if="isCompleted"
          class="text-center shadow-lg border-0 p-4"
        >

          <h2 class="font-weight-bold mb-2">
            Report Generated Successfully
          </h2>

          <p class="text-muted mb-4">
            Your Standard Chartered portfolio report is ready.
          </p>

          <!-- Download Cards -->
          <b-row class="mb-4">
            <b-col cols="12" md="6" v-if="pptUrl">
              <b-card class="file-card ppt text-center mb-3 mb-md-0">
                <h6 class="mt-2">PPT Report</h6>
                <b-button
                  variant="outline-danger"
                  size="sm"
                  :href="pptUrl"
                  target="_blank"
                >
                  Download PPT
                </b-button>
              </b-card>
            </b-col>

            <b-col cols="12" md="6" v-if="xlsxUrl">
              <b-card class="file-card xlsx text-center">
                <h6 class="mt-2">Excel Report</h6>
                <b-button
                  variant="outline-success"
                  size="sm"
                  :href="xlsxUrl"
                  target="_blank"
                >
                  Download Excel
                </b-button>
              </b-card>
            </b-col>
          </b-row>

          <!-- CTA -->
          <b-button
            variant="primary"
            size="lg"
            class="px-4"
            @click="goToEvalution"
          >
            Generate Another Report
          </b-button>

          <b-button
            variant="primary"
            size="lg"
            class="px-4"
            @click="goToReports"
          >
            View All Reports
          </b-button>



        </b-card>

        <!-- ⏳ LOADING STATE -->
        <b-card
          v-else
          class="text-center shadow-sm border-0 p-5"
        >
          <b-spinner variant="primary" class="mb-3" />
          <h5>Generating your report…</h5>
          <p class="text-muted mb-0">
            Please wait, this may take a few seconds.
          </p>
        </b-card>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  name: "StandardChartered",

  computed: {
    ...mapState("addholdings", {
      scReport: state => state.standardCharteredReport
    }),

    pptUrl() {
      return this.scReport?.pptUrl;
    },

    xlsxUrl() {
      return this.scReport?.xlsxUrl;
    },

    isCompleted() {
      return Boolean(this.pptUrl || this.xlsxUrl);
    }
  },


  methods: {

  ...mapActions("addholdings", {
      setEnableReport: "setEnableReport",
    }),


    goToReports() {
      this.$router
        ? this.$router.push("/reports")
        : (window.location.href =
            "/reports");
    },

     goToEvalution() {
     localStorage.removeItem("reEvaluatePortfolioData")
      localStorage.removeItem("preLoginHoldingsData");
      window.location.reload()
    }
  }
};
</script>

<style scoped>
.report-success-page {
  background: #f4f7fb;
  min-height: 70vh;
}

.success-icon {
  color: #28a745;
}

.file-card {
  border-radius: 12px;
  border: 1px solid #eaeaea;
}

.file-card.ppt {
  background: #fff6f4;
}

.file-card.xlsx {
  background: #f4fbf6;
}

.file-card h6 {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/StandardChartered.vue